import moment from 'moment';

const unit = 'milliseconds';

/**
 * Box for a number representing a duration.
 */
export class Duration {
  private readonly value: number;

  public constructor(value: number) {
    this.value = value;
  }

  public valueOf() {
    return this.value;
  }
}

/**
 * Handles serialization and deserialization of ISO 8601 durations.
 */
export const DurationMarshaller = {
  deserialize: (value: unknown): Duration => {
    if (typeof value !== 'string') {
      throw new Error(`Expected ${value} to be a string.`);
    }

    const duration = moment.duration(value);

    // Moment does not support the validation of duations, as it stands.
    // https://github.com/moment/moment/issues/1805
    // However, this test is to futureproof the code so when it does work it will produce an
    // error.
    if (!duration.isValid() || !isFinite(duration.as(unit))) {
      throw new Error(`${value} cannot be parsed into a duration.`);
    }

    return new Duration(duration.as(unit));
  },
  serialize: (value: Duration): string => {
    return moment.duration(value.valueOf(), unit).toISOString();
  },
};
